<template>
    <div id="main-modal">
        <div class="listing-header mb-3">
            <div class="title-breadcrumb">
                <h1 class="title">
                    {{ $t('motivo') }}
                </h1>
            </div>
            <div class="header-buttons">
                <button 
                    class="delete-btn" 
                    type="button" 
                    @click="fecharModal()"
                >
                    {{ $t("cancelar") }}
                </button>
                <button 
                    class="save-btn" 
                    type="button" 
                    @click="save" 
                    :disabled="isLoadingEdit"
                >
                    {{ $t("salvar") }}
                </button>
            </div>
        </div>
        <br />

        <div class="form-columns-fit">
            <div class="columns is-flex-wrap">
                <div class="column is-6">
                    <vss-select
                        :id="generateId(1)"
                        ref="motivoSelect"
                        title="motivo"
                        searchable
                        :options="motivoSelect"
                        v-model="motivoSelected"
                        :required="true"
                        :invalid="isNull(motivoSelected)"
                        :loading="motivoLoading"
                        @search="loadMotivo"
                        @onBlurFunction="sendIsChanged('motivo')"
                    />
                </div>
                <div class="column is-6">
                    <v-input
                        :id="generateId(2)"
                        ref="descricaoInput"
                        v-model="motivoregistro.descricao"
                        :maxlength="500"
                        title="descricao"
                        placeholder="placeholder-preencha"
                        msg="msg-campo-obrigatorio"
                        :invalid="isNull(motivoregistro.descricao)"
                        :required="true"
                    />
                </div>
                <div 
                    class="column is-6"
                    v-if="permissaoFields.contato>0"
                >
                    <v-input
                        :id="generateId(5)"
                        ref="contatoInput"
                        v-model="motivoregistro.contato"
                        :maxlength="255"
                        title="contato"
                        placeholder="placeholder-preencha"
                        msg="msg-campo-obrigatorio"
                        :required="permissaoFields.contato==2"
                        :invalid="permissaoFields.contato==2
                            &&isNull(motivoregistro.contato)"
                    />
                </div>
                <div 
                    class="column is-12" 
                    v-if="permissaoFields.observacao>0
                ">
                    <v-textarea
                        ref="observacaoTextarea"
                        :id="generateId(7)" 
                        v-model="motivoregistro.observacao"
                        title="observacao"
                        placeholder="placeholder-preencha"
                        :required="permissaoFields.observacao==2"
                        :invalid="permissaoFields.observacao==2
                            &&isNull(motivoregistro.observacao)"
                        :rows="6"
                        :maxRows="6"
                        :disableTransform="true"
                        :maxlength="1000"
                    />
                </div>
                <div 
                    class="column is-12"
                    v-show="motivoSelected!=null"
                >
                    <multiple-img-picker
                        :id="generateId(10)"
                        ref="imagePicker"
                        title="fotos"
                        :subtitle="` (Quantidade Mínima ${permissaoFields.qtdeminimafoto})`"
                        :msg="permissaoFields.qtdeminimafoto>0?'msg-campo-obrigatorio':null"
                        :qtdeminimafoto="permissaoFields.qtdeminimafoto"
                        @uploadedFiles="obterFotos"
                        :showOldPhotos="false"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MotivoRegistroService from "@/services/agro/MotivoRegistroService";
import MotivoService from "@/services/agro/MotivoService";
import MotivoRegitroValidation from "@/services/validations/agro/MotivoRegitroValidation";
import MultipleImgPicker from "@/components/shared/form/MultipleImgPicker";

export default {
    components: {
        MultipleImgPicker,
    },
    props: {
        uuid: {
            type: String,
            default: null
        },
    },
    data() {
        return {
            showForm: true,
            service: new MotivoRegistroService(this.$http, this.$router),
            motivoService: new MotivoService(this.$http, this.$router),
            validation: new MotivoRegitroValidation(this.msgs),
            isLoading: false,
            isSaving: false,
            //para controlar algumas ações até os dados serem carregados na edição
            isLoadingEdit: false,
            msgs: [],
            motivoregistro: {
                uuid: null,
                idmotivo: null,
                idexterno: null,
                uuidexterno: this.uuid,
                descricao: null,
                contato: null,
                observacao: null,
                replicapda: null,
                latitude: null,
                longitude: null,
                lastfix: null,
                tipogps: null,
                motivoregistrofoto: [],
                origem: 'PROPRIEDADE_INATIVA'
            },
            motivoSelect: [],
            motivoSelected: null,
            motivoLoading: true,

            permissaoFields: {
                contato: 0,
                observacao: 0,
                qtdeminimafoto: 0,
            },
            permissaoFieldsClean: {},
            
            
        };
    },
    created() {
        this.$emit("isChangedModal", false);
        this.permissaoFieldsClean = Object.assign({}, this.permissaoFields);
    },
    watch: {
        motivoregistro: {
            deep: true,
            handler: function () {
                if (!this.isLoadingEdit) {
                    this.$emit("isChangedModal", true);
                }
            },
        },
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + "-motivo-" + numberId;
        },
        // Emite ao componente pai se houve alteração em um campo select
        sendIsChanged(label=null) {
            if (!this.isLoadingEdit) this.$emit("isChangedModal", true);

            if(label=='motivo') {
                this.isLoading = true;
                this.permissaoFields = Object.assign({}, this.permissaoFieldsClean);
                if(this.motivoSelected!=null){
                    setTimeout(() => {
                        this.loadMotivoPermissao();
                    }, 300);
                }else{
                    this.isLoading = false;
                }
            }
        },
        fecharModal() {
            this.$emit("fecharModal", true);
        },
        loadMotivo(termo = null) {
            this.motivoLoading = true;

            let params = [  // Adicionar filtro complementar
                this.isNull(termo) ? '.*' : this.removeToSearch(termo),
                // parâmetro adicional com o nome do que deve ser filtrado
                'origem',
                // parâmetro adicional com o id do que deve ser usado no filtro
                'PROPRIEDADE_INATIVA',
            ];

            this.motivoService
                .findAllCombo(params)
                .then(body => {
                    return body.content.map(m => {
                        return {
                            id: m.id,
                            label: m.descricao,
                            cor: m.cor,
                            icone: m.icone.toLowerCase(),
                        };
                    });
                })
                .then(r => {
                    this.motivoSelect = Object.assign(r);
                    if(this.motivoSelect.length==1){
                        this.motivoSelected = this.motivoSelect[0];
                        this.sendIsChanged('motivo');
                    }else if(this.motivoSelect.length == 0) {
                        // caso não tenha motivo a ação deve ocorrer automaticamente
                        this.$emit("save", true);
                    }
                })
                .catch(e => {
                    this.$root.showMessage("error", "msg-erro-load");
                    console.error(`Erro ao realizar pesquisa. Termo: [${termo}]`, e);
                })
                .finally(_ => {
                    this.motivoLoading = false;
                });
        },
        loadMotivoPermissao() {
            this.motivoService
                .find(this.motivoSelected.id)
                .then(r => {
                    if(r.content){
                        this.permissaoFields.contato = +r.content.habilitaobrigacontato;
                        this.permissaoFields.observacao = +r.content.habilitaobrigaobservacao;
                        this.permissaoFields.qtdeminimafoto = +r.content.qtdeminimafoto;
                    }else{
                        this.permissaoFields = Object.assign({}, this.permissaoFieldsClean);
                        this.$root.showMessage("error", "msg-erro-load");
                    }
                })
                .catch(e => {
                    this.$root.showMessage("error", "msg-erro-load");
                })
                .finally(_ => {
                    this.isLoading = false;
                });
        },
        obterFotos(fotos) {
            let temp_fotos = [];
            fotos.forEach((foto, i) => {
                temp_fotos[i] = {
                    nome: foto.fileName,
                    caminho: foto.url.replace(/^data:(.*,)?/, ''),
                    documentopda: {
                        nome_documento: foto.fileName,
                        url_documento: '',
                    },
                };
            });
            this.motivoregistro.motivoregistrofoto = temp_fotos;
        },
        successPosition(position){
            this.motivoregistro.latitude = (position.coords.latitude)?position.coords.latitude:0;
            this.motivoregistro.longitude = (position.coords.longitude)?position.coords.longitude:0;
            this.motivoregistro.lastfix = (position.timestamp)?position.timestamp:null;
            this.motivoregistro.tipogps = (position.coords.latitude)?1:0;
            console.info(position);
        },
        errorPosition(e){
            console.error('Geolocation error!', e);
        },
        save() {
            this.isLoading = true;
            // pega alocalização através do navegador caso esteja liberado
            if (navigator.geolocation) {
                console.log('Geolocation is supported by this browser');
                navigator.geolocation.getCurrentPosition(this.successPosition, this.errorPosition);
            } else {
                console.log('Geolocation is not supported by this browser');
            }
            setTimeout(() => {
                let motivoregistroTemp = Object.assign({}, this.motivoregistro);
                // monta dados complementares
                motivoregistroTemp.idmotivo = 
                    this.motivoSelected!=null ? this.motivoSelected.id : null;

                if(this.validation.validate(motivoregistroTemp, this.permissaoFields, this.$refs)
                ){
                    motivoregistroTemp = this.mapTosave(motivoregistroTemp);

                    this.isSaving = true;
                    this.service.save(motivoregistroTemp)
                        .then(value => {
                            if (value.message == null) {
                                
                                // novo modelo de mensagem dinâmica
                                let msg = this.$t(
                                    this.isUpdate
                                        ?'msg-edit-sucesso-n'
                                        :'msg-save-sucesso-n', 
                                    { n: this.$t('motivo') }
                                );
        
                                this.$root.showMessage('success', msg, true, false);
        
                                this.$emit("isChanged", false);
                                this.$emit("save", true);
                            } else {
                                if (this.$t(value.message)) {
                                    this.$root.showMessage('alert', value.message, true);
                                } else {
                                    this.$root.showMessage('error', 'msg-problema-realizar-acao', true);
                                }
                            }
                        })
                        .catch((e) => {
                            this.$root.showMessage('error', 'msg-problema-realizar-acao', true);
                        })
                        .finally(() => {
                            this.isSaving = false;
                            this.isLoading = false;
                        });
                } else {
                    this.$root.showMessage('alert', 'msg-campos-obrigatorios', true);
                    this.isLoading = false;
                }
            }, 300);
        },
    },
};
</script>

<style lang="scss" scoped>
#main-modal {
    padding: 20px 20px;
}
</style>